import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import './Singleemployee.css';
import './Sendinvite.css';
import Invitesent from './Invitesent';

function Singleemployee(props) {
  const [showSecondModal, setShowSecondModal] = useState(false);
  const [showEmployeeDetailsModal, setShowEmployeeDetailsModal] = useState(false);
  const [additionalFields, setAdditionalFields] = useState([]);
  const [newFieldLabel, setNewFieldLabel] = useState('');
  const [newFieldValue, setNewFieldValue] = useState('');
  const [showAddField, setShowAddField] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [addingField, setAddingField] = useState(false);

  const handleShowSecondModal = () => {
    setShowSecondModal(true);
  };

  const handleShowEmployeeDetailsModal = () => {
    setShowEmployeeDetailsModal(true);
  };

  const handleCloseEmployeeDetailsModal = () => {
    setShowEmployeeDetailsModal(false);
  };

  const [showInviteSentModal, setShowInviteSentModal] = useState(false);

  const handleCloseInviteSentModal = () => {
    setShowInviteSentModal(false);
  };
  

  const handleShowInvitesentModal = () => {
    setShowInviteSentModal(true);
  };

  const handleAddField = () => {
    if (newFieldLabel && newFieldValue) {
      setAdditionalFields([
        ...additionalFields,
        { label: newFieldLabel, placeholder: newFieldValue },
      ]);
      setNewFieldLabel('');
      setNewFieldValue('');
      setAddingField(false);
    }
  };

  const handleEditField = (index) => {
    console.log(`Edit field ${index}`);
  };

  const handleDeleteField = (index) => {
    const updatedFields = additionalFields.filter((field, i) => i !== index);
    setAdditionalFields(updatedFields);
  };

  const handleShowSuccessModal = () => {
    setShowSuccessModal(true);
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
        <div>

          <Modal {...props} aria-labelledby="contained-modal-title-vcenter">
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">Add employee details</Modal.Title>
            </Modal.Header>
            <Modal.Body className="grid-example">
            <div className="container-">
                <div className="header-main">
                  <div className="header-text">
                    <h4 className="">Add employee details</h4>
                    <p className="description">Fill out the form below to send an employee invite.</p>
                  </div>
                  <div className='close-icon' onClick={handleCloseEmployeeDetailsModal}>
                    {/* Close button, replace this with your close action */}
                    {/* <button></button> */}
                  </div>
                </div>

                <div className="form-container">
                  <div className="text-group">
                    <div className="text-fields d-flex">
                      <div className="firstName-field">
                        <label className="label mt-2">First Name</label>
                        <input type="text" className="form-field w-100" placeholder="Enter the input" />
                      </div>
                      <div className="lastName-field">
                        <label className="label mt-2">Last Name</label>
                        <input type="text" className="form-field w-100 mx-2" placeholder="Enter the input" />
                      </div>
                    </div>

                    <div className="text-fields d-flex">
                      <div className="email-field">
                        <label className="label mt-2">Email</label>
                        <input type="email" className="email-field" placeholder="Enter the input" />
                      </div>
                    </div>

                    <div className="text-fields d-flex mt-2">
                      <div className="field-group">
                        <label className="label mt-2">Phone Number</label>
                        <input type="tel" className="phone-field" placeholder="Enter the input" />
                      </div>
                    </div>

                    <div className="text-fields d-flex mt-2">
                      <div className="job-field">
                        <label className="label mt-1">Job Role</label>
                        <select className="form-field mt-1 p-2 w-85">
                          <option value="select-role">Select role</option>
                          <option value="role1">Marketing</option>
                          <option value="role2">Information technology</option>
                          <option value="role3">Customer support</option>
                          <option value="role4">Other</option>
                        </select>
                      </div>

                      <div className="text-fields d-flex">
                        <div className="date-field">
                          <label className="label mt-2">Date of Employment</label>
                          <input type="date" className="form-field w-100 mx-2" />
                        </div>
                      </div>
                    </div>

                    {additionalFields.map((field, index) => (
                      <div className="field-group w-100">
                        <label className="label w-100">{field.label}:</label>
                        <input type="text" className="form-field w-100" placeholder={field.placeholder} />
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="addEmployeeField mt-4">
                {addingField ? (
                  <div className="addButton ">
                    <label>Add another employee detail:</label>
                    <div className="labelInput w-100 mt-2">
                      <input
                        type="text"
                        placeholder="Name the input"
                        value={newFieldLabel}
                        onChange={(e) => setNewFieldLabel(e.target.value)}
                      />
                    </div>
                    <div className="placeholderInput w-100 mt-2">
                      <input
                        type="text"
                        placeholder="Enter the input"
                        value={newFieldValue}
                        onChange={(e) => setNewFieldValue(e.target.value)}
                      />
                    </div>
                    <button className="addText mt-2" onClick={handleAddField}>Add</button>

                    {/* Adding a button to close the "Add" section */}
                    <button className="addText mt-2" onClick={() => setAddingField(false)}>Close</button>
                  </div>
                ) : (
                  <button className="addButton mt-2" onClick={() => setAddingField(true)}>Add another employee detail</button>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button className="submit-form w-100" variant="primary" onClick={handleShowInvitesentModal}>
                Submit employee detail
              </Button>
            </Modal.Footer>
          </Modal>

        </div>
  );
}

export default Singleemployee;